import { Box, Typography } from "@mui/material";
import { PipelineColumnConfig } from "./pipelineColumns";
import { PipelinePickup } from "./types";
import PipelineCard from "./PipelineCard";

type Props = {
  column: PipelineColumnConfig;
  pickups: PipelinePickup[];
  onAction: (pickup: PipelinePickup) => void;
  advancingUuid?: string | null;
};

const COLUMN_WIDTH = 288;

export default function PipelineColumn({ column, pickups, onAction, advancingUuid }: Props) {
  return (
    <Box
      sx={{
        flex: "1 0 288px",
        width: COLUMN_WIDTH,
        minWidth: COLUMN_WIDTH,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "background.paper",
        borderRadius: "12px",
        border: "1px solid #ECECEC",
        overflow: "hidden",
        boxShadow: "0 1px 2px rgba(0, 0, 0, 0.04)",
      }}
    >
      <Box
        sx={{
          borderTop: `4px solid ${column.borderColor}`,
          px: 2,
          pt: 1.75,
          pb: 1.25,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1.5,
          flexShrink: 0,
        }}
      >
        <Typography
          sx={{
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: 0.7,
            color: "#424242",
            lineHeight: 1.3,
            textTransform: "uppercase",
          }}
        >
          {column.title}
        </Typography>
        <Box
          sx={{
            minWidth: 26,
            height: 26,
            borderRadius: "50%",
            backgroundColor: column.badgeColor,
            color: column.badgeTextColor,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 12,
            fontWeight: 700,
            flexShrink: 0,
          }}
        >
          {pickups.length}
        </Box>
      </Box>

      <Box
        component="ul"
        sx={{
          listStyle: "none",
          m: 0,
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          overflowX: "hidden",
          px: 1.5,
          pb: 1.5,
          pt: 0.25,
          WebkitOverflowScrolling: "touch",
          "&::-webkit-scrollbar": { width: 6 },
          "&::-webkit-scrollbar-thumb": { backgroundColor: "#D6D6D6", borderRadius: 3 },
        }}
      >
        {pickups.map((pickup) => (
          <Box component="li" key={pickup.id} sx={{ display: "block" }}>
            <PipelineCard pickup={pickup} onAction={onAction} advancing={advancingUuid === pickup.uuid} />
          </Box>
        ))}
      </Box>
    </Box>
  );
}
